var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjectDetailWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .cls-1, .cls-2 {\r\n        fill: #fff;\r\n        stroke: #fff;\r\n      }\r\n\r\n      .cls-2 {\r\n        stroke-linecap: round;\r\n      }\r\n\r\n      .cls-3 {\r\n        stroke: none;\r\n      }\r\n\r\n      .cls-4 {\r\n        fill: none;\r\n      }\r\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9970",
    "data-name": "Group 9970",
    transform: "translate(21802 2266)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1829",
    "data-name": "Ellipse 1829",
    className: "cls-1",
    transform: "translate(-21791 -2266)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1830",
    "data-name": "Ellipse 1830",
    className: "cls-1",
    transform: "translate(-21802 -2266)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_1831",
    "data-name": "Ellipse 1831",
    className: "cls-1",
    transform: "translate(-21794 -2255)"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 2.5,
    cy: 2.5,
    r: 2.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 2.5,
    cy: 2.5,
    r: 2
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_7383",
    "data-name": "Path 7383",
    className: "cls-2",
    d: "M-21797-2263.5h5.139"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7384",
    "data-name": "Path 7384",
    className: "cls-2",
    d: "M-21798.172-2261.476l4.707,5.967"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjectDetailWhite);
export default __webpack_public_path__ + "static/media/ProjectDetailWhite.77d86e14f600f96355078da2dd06387d.svg";
export { ForwardRef as ReactComponent };